var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('SideBar',{staticClass:"sidebar",attrs:{"apiData":_vm.apiData}}),_c('section',{staticClass:"main-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }